import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { CompensationMethodState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/compensation-method";
import { getLabelForReturnOption } from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-method";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const CompensationMethodDetails = memo(
  function CompensationMethodDetails({
    state,
    setState,
    disabled,
  }: ConditionTypeDetailsProps<CompensationMethodState>) {
    const compensationMethodOptions: RedoListItem<
      ReturnOptionMethod["type"]
    >[] = useMemo(
      () =>
        (
          [
            ReturnOptionMethod.EXCHANGE,
            ReturnOptionMethod.REFUND,
            ReturnOptionMethod.STORE_CREDIT,
          ] as const
        ).map((method) => ({
          id: method,
          value: method,
          type: "text" as const,
          text:
            method === ReturnOptionMethod.EXCHANGE
              ? "Same item exchange"
              : getLabelForReturnOption(method),
        })),
      [],
    );

    const selectedMethod = state.compensationMethod
      ? compensationMethodOptions.find(
          (option) => option.value === state.compensationMethod,
        )
      : undefined;

    return (
      <RedoSingleSelectDropdownInput
        description="Condition will match if any selected items have this compensation method"
        disabled={disabled}
        flexGrow
        label="Compensation method"
        options={compensationMethodOptions}
        optionSelected={({ item }) =>
          setState({ ...state, compensationMethod: item.value })
        }
        placeholder="Select method..."
        selectedItem={selectedMethod}
        size="xs"
      />
    );
  },
);
